import { useTranslation } from 'react-i18next'

import PlainNav, { NavItem } from 'app/common/ui/PlainNav'
import { useCompensationEnabledByStudent } from 'app/dataProviders/user/hooks'

import styles from './Navigation.scss'


type Props = {
  baseURL: string
  isIteko: boolean
  isCamp: boolean
  studentID: string
}

const Navigation = ({
  baseURL,
  isIteko,
  isCamp,
  studentID,
}: Props) => {
  const { t } = useTranslation('cafeteria')
  const financesActive = /^\/apps\/(\d+)\/cafeteria\/general\/paymentOrders$/.test(window.location.pathname)
  const {
    compensationByStatement,
    compensationByCabinet,
  } = useCompensationEnabledByStudent(studentID)

  return (
    // div здесь нужен, для нормального функционирования прилипания
    <div className={styles.root}>
      <PlainNav className={styles.mainMenu}>
        <NavItem to={`${baseURL}/menu`}>
          {t('nav_menu', 'Меню')}
        </NavItem>
        {!isIteko && !isCamp && <NavItem to={`${baseURL}/orders`}>
          {t('nav_orders', 'Заказы')}
        </NavItem>}
        <NavItem to={`${baseURL}/orderRequests`}>
          {isCamp
            ? t('nav_order_requests_camp', 'Заявки на лагерь')
            : t('nav_order_requests', 'Заявки на класс')}
        </NavItem>
        {!isCamp && <NavItem to={`${baseURL}/purchases`}>
          {t('nav_purchases', 'Покупки')}
        </NavItem>}
        {!isIteko && !isCamp && <NavItem to={`${baseURL}/schedule`}>
          {t('nav_schedule', 'График питания')}
        </NavItem>}
        <NavItem to={`${baseURL}/finances`} active={financesActive}>
          {t('nav_finances', 'Финансы')}
        </NavItem>
        {!isIteko && <NavItem to={`${baseURL}/subsidies`}>
          {t('nav_subsidies', 'Дотации')}
        </NavItem>}
        {(compensationByStatement || compensationByCabinet)
          && <NavItem to={`${baseURL}/compensation`}>
            {t('nav_compensation', 'Компенсация')}
          </NavItem>}
        <NavItem to={`${baseURL}/settings`}>
          {t('nav_settings', 'Настройки')}
        </NavItem>
      </PlainNav>
    </div>
  )
}

export default Navigation
